[
  {
    "id": "utopia",
    "name": "Utopia",
    "maxChannels": 3,
    "channelCapacity": 100,
    "openNextAtPct": 80,
    "maxPlayers": 200
  }
]
